import { Component, OnInit } from '@angular/core';

import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { CommonService } from "../../../shared/common.service";
import { AuthServiceLocal } from "../../auth.service";
import { Router } from "@angular/router";
import { HttpResponse } from "@angular/common/http";
import { StreamService } from "../../../shared/stream.service";
import { MatSnackBar } from '@angular/material/snack-bar';
@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss']
})
export class SigninComponent implements OnInit {
  loginForm: FormGroup;
  formSubmitted: boolean = false;
  isLoading: boolean = false;
  show: boolean = false;
  isLogin: boolean = true;
  emailPattern = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
  constructor(
    private fb: FormBuilder,
    private authServices: AuthServiceLocal,
    private commonService: CommonService,
    private streamService: StreamService,
    private router: Router,
    private _snackBar: MatSnackBar,) { }

  ngOnInit() {
    this.initialiseForms();

  }


 

  initialiseForms() {
    this.loginForm = this.fb.group({
      email: ["", [Validators.required, Validators.pattern(this.emailPattern)]],
      password: ["", [Validators.required, Validators.minLength(6)]],
    });

  }

  login() {

    this.formSubmitted = true;
    let req = {
      email: this.loginForm.controls["email"].value.trim(),
      password: this.loginForm.controls["password"].value.trim(),
      userType: "admin",
      mobileType:"web",
    };
    this.isLoading = true;
    this.authServices.validateLogin(req).subscribe(
      (res: HttpResponse<any>) => {
       
        this.isLoading = false;
        if ((res.body["success"] ==true)) {
       
          if (res.body.data["token"]) {
            this.commonService.setStorage(
              "token",
              res.body.data["token"]
            );
          }
          let userData = this.commonService.getUser();
          
          if (userData['userType'] == 'admin') {
            this.router.navigate(["/dashboard"])
          } else {
            this._snackBar.open("You Don't have an access for this portal", "", {
              duration: 3000,
              horizontalPosition: "right",
              verticalPosition: "top",
              panelClass: ["success"],
            });
          }

          localStorage.setItem("role", userData['userType'])
          localStorage.setItem("activeIndex", "0");
          localStorage.setItem("userData", JSON.stringify(res.body.data.user));

          this.sendRouteVal(0);
        }
      },
      err => {

        this._snackBar.open(err.error.data, "", {
          duration: 3000,
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: ["success"],
        });
        this.isLoading = false;
      }
    );
  }

  sendRouteVal(index) {
    this.streamService.streamMessage(index)
    // this.messageEvent.emit(index);
  }
  password() {
    this.show = !this.show;
  }

}
